import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=1b97954f&scoped=true&lang=pug&"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=1b97954f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97954f",
  null
  
)

export default component.exports